
import { Menu } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

interface TabMenuItem {
  id: string;
  title: string;
}

interface TabMenuProps {
  tabItems: TabMenuItem[];
  activeTab: string;
  onTabChange: (value: string) => void;
  onBackToMainView: () => void;
}

const TabMenu = ({ tabItems, activeTab, onTabChange, onBackToMainView }: TabMenuProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button 
          className="p-2 rounded-full bg-slate-800 hover:bg-slate-700 transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500"
          aria-label="Navigation menu"
        >
          <Menu className="w-5 h-5 text-gray-300" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="end" 
        className="bg-slate-800 border-slate-700 text-white w-48 p-1"
      >
        {tabItems.map((tab) => (
          <DropdownMenuItem 
            key={tab.id} 
            className={`flex items-center px-3 py-2 cursor-pointer hover:bg-slate-700 rounded-md text-sm ${activeTab === tab.id ? 'bg-slate-700 font-medium' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.title}
          </DropdownMenuItem>
        ))}
        <DropdownMenuItem 
          className="flex items-center px-3 py-2 cursor-pointer hover:bg-slate-700 rounded-md text-sm border-t border-slate-700 mt-1 pt-2"
          onClick={onBackToMainView}
        >
          Back to all resources
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TabMenu;
